export default __webpack_public_path__ + "media/images/ico-email-bc0f7ff6232f68de8bb29773a0c547f1.svg";